import { EdiApiUsers } from "../EdiApiUsers";
import { EdiNotify } from "../EdiNotify";
import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiRemitAdvProf extends Layout {
    buttonAckTemplateSetup: Button;
    buttonFaMasterBatch: Button;
    buttonFilenameCustomize: Button;
    buttonOpenClassic: Button;
    buttonSetup: Button;
    buttonTransactionCustomize: Button;
    checkboxFuncUseMBatch: Checkbox;
    checkboxProcess: Checkbox;
    checkboxSendFuncAck: Checkbox;
    dataheaderGenericProfile: DataHeader;
    labelDirectionOutbound: Label;
    labelFuncMasterBatch: Label;
    labelNextBatchNumber: Label;
    layoutEdiApiUsers: EdiApiUsers;
    layoutNotifications: EdiNotify;
    panelFuncBatch: Panel;
    panelHeader: Panel;
    panelNotes: Panel;
    panelOutboundFuncAck: Panel;
    sourceEdiApiUser: DataSource;
    sourceEdiFuncAckTemplate: DataSource;
    sourceEdiNotify: DataSource;
    sourceEdiTemplate: DataSource;
    sourceEdiremitProfile: DataSource;
    tabApiUsers: Tab;
    tabFunctionalAcknowledgement: Tab;
    tabGeneral: Tab;
    tabNotifications: Tab;
    tabPartnerNotes: Tab;
    tabsetRemitProfile: Tabset;
    textboxAckXmitMethod: Textbox;
    textboxAltPartnerId: Textbox;
    textboxCommId: Textbox;
    textboxDirection: Textbox;
    textboxFuncAckFilename: Textbox;
    textboxFuncAckSt02Frmt: Textbox;
    textboxFuncAckTid: Textbox;
    textboxFuncAltpartnerId: Textbox;
    textboxFuncCommId: Textbox;
    textboxFuncNextBatch: Textbox;
    textboxFuncPartnerId: Textbox;
    textboxFuncVersion: Textbox;
    textboxNextBatch: Textbox;
    textboxNotes: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxProcessPriority: Textbox;
    textboxRecordUpdateMethod: Textbox;
    textboxTemplateId: Textbox;
    textboxTransactionSet: Textbox;
    textboxVersion: Textbox;
}
